import { AbilityBuilder, createMongoAbility, MongoAbility } from '@casl/ability';

export type AppAbilities = [string, string]; // e.g., ['create', 'person']
export type AppAbility = MongoAbility<AppAbilities>;

/**
 * Creates a CASL Ability object from an array of permission strings.
 * @param permissions - An array of strings like "action:subject".
 * @returns A CASL Ability instance of type `AppAbility`.
 */
export function buildAbilityFor(permissions: string[]): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (!permissions || permissions.length === 0) {
    return build();
  }

  permissions.forEach(permissionString => {
    const parts = permissionString.split(':');
    if (parts.length === 2) {
      const [action, subject] = parts;
      can(action, subject);
    }
  });

  return build();
}
